import BreadCrumb from "../screens/Common/BreadCrumb";
import React from "react";

import LayoutContainer from "../screens/layout/admin-dashboard";
import MastersList from "../screens/masters/MastersList";

const breadCrumbData = [{ link: "/masters-list", name: "Masters" }];

const Home = () => (
  <>
    <LayoutContainer>
      <BreadCrumb data={breadCrumbData} />
      <MastersList />
    </LayoutContainer>
  </>
);

export default Home;
